import { extendVariants, Spinner as HeroSpinner, SpinnerProps } from '@heroui/react';
import { twMerge } from 'tailwind-merge';

import { HeroBaseProps } from '../utils';

// For all Spinner props see https://v2.heroui.com/docs/components/spinner
export const Spinner = extendVariants(
  (
    props: HeroBaseProps<SpinnerProps, 'size' | 'color'> & {
      size?: Extract<SpinnerProps['size'], 'xs' | 'sm' | 'md' | 'lg'>;
      color?: Extract<SpinnerProps['color'], 'primary' | 'secondary' | 'danger' | 'warning' | 'success'>;
    },
  ) => <HeroSpinner {...props} className={twMerge('flex', props.className)} />,
  {
    defaultVariants: {
      color: 'secondary',
    },
    variants: {
      color: {
        primary: {
          circle1: 'border-b-primary-500',
          circle2: 'border-b-primary-500',
        },
        secondary: {
          circle1: 'border-b-secondary-500',
          circle2: 'border-b-secondary-500',
        },
        success: {
          circle1: 'border-b-success-500',
          circle2: 'border-b-success-500',
        },
        warning: {
          circle1: 'border-b-warning-500',
          circle2: 'border-b-warning-500',
        },
        danger: {
          circle1: 'border-b-danger-500',
          circle2: 'border-b-danger-500',
        },
      },
      size: {
        '2xs': {
          wrapper: 'w-2 h-2',
          circle1: 'border-1.5',
          circle2: 'border-1.5',
        },
        xs: {
          wrapper: 'w-3 h-3',
          circle1: 'border-2',
          circle2: 'border-2',
        },
        sm: {
          wrapper: 'w-4 h-4',
          circle1: 'border-2',
          circle2: 'border-2',
        },
        md: {
          wrapper: 'w-5 h-5',
          circle1: 'border-2',
          circle2: 'border-2',
        },
        lg: {
          wrapper: 'w-6 h-6',
          circle1: 'border-3',
          circle2: 'border-3',
        },
        xl: {
          wrapper: 'w-7 h-7',
          circle1: 'border-3',
          circle2: 'border-3',
        },
      },
    },
  },
);
